<template>

      <b-card>
        <LumaDatatable  url="accounting/billings"
                        :columns="columns"
                        :model="billingModel">
          <template v-slot:actions="slotProps">
            <b-button variant="white small"
                      @click="pdf(slotProps.item.number)"
                      size="xs">
              Ansehen
            </b-button>
          </template>
        </LumaDatatable>
        <b-modal id="pdf" size="xl">
          <iframe style="height: 800px; width: 100%;" :src="pdf_data"></iframe>
        </b-modal>
      </b-card>
</template>

<script>
    import LumaDatatable from "@/components/LumaDatatable"
    import {Billing} from "@/store/models/accounting/billing";
    import axios from "axios";
    import ApiRoutesModel from "@/store/models/layout/api_routes";
    export default {
        name: "luma-accounting-bill",
        components: {
          LumaDatatable
        },
        data:()=>({
          billingModel:Billing,
          pdf_data:null
        }),
        computed:{
            columns(){
                return [
                    {
                        key: 'number',
                        column: 'number',
                        filter: false,
                        order: true
                    },
                    {
                        key: 'user',
                        column: 'user',
                        filter: false,
                        order: true
                    },
                    {
                        key: 'date',
                        column: 'date',
                        filter: false,
                        order: true
                    },
                    {
                        key: 'due_date',
                        column: 'due_date',
                        filter: false,
                        order: true
                    },
                    {
                        key: 'brutto',
                        column: 'brutto',
                        filter: false,
                        order: true
                    },
                    {
                        key: 'state',
                        column: 'state',
                        filter: false,
                        order: true
                    },
                    {
                        key: 'actions',
                        column: 'actions',
                        filter: false,
                        order: false,
                        slot: true
                    }
                ]
            }
        },
        methods:{
            b64(val){
              this.pdf_data = val
              this.$bvModal.show('pdf')
            },
            async pdf(number){
                var result = null
                const API_URL = process.env.API_URL
                const url = "/accounting/billings/" +number+ "/download"
                const obj = axios.create({
                    baseURL: API_URL,
                    headers: {
                        'accept-language': 'en,de',
                        'accept': 'application/pdf',
                        'content-type' : 'application/pdf',
                        'Authorization': 'Bearer '+ localStorage.getItem('authToken')
                    },
                    responseType: 'blob'
                })
                const y = await obj.get(url)
                      .then(response=>{
                            // PDF DATA
                            let pdf = response.data
                            let reader = new FileReader()
                            reader.readAsDataURL(pdf)
                            reader.onloadend = ()=>{
                              this.b64(reader.result)
                          }
                        }
                      )
                      .catch(error=>{
                        console.log('PDF ERROR:::',error)
                      })

            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/bill_accounting/luma-accounting-bill.vue